import global from './english-modules/global'
import login from './english-modules/login'
import header from './english-modules/header'
import sidebar from './english-modules/sidebar'
import dashboard from './english-modules/dashboard'
import communications from './english-modules/communications'
import careCoordinator from './english-modules/careCoordinator'
import patient from './english-modules/patients'
import appointmentCalendar from './english-modules/appointmentCalendar'
import tasks from './english-modules/tasks'
import timeTrackingReport from './english-modules/timeTrackingReport'
import thresholds from './english-modules/thresholds'
import timeLogReport from './english-modules/timeLogReport'
import patientSummary from './english-modules/patientSummary'
import common from './english-modules/common'
import globalCodes from './english-modules/globalCodes'
import providers from './english-modules/providers'
import inventory from './english-modules/inventory'
import roles from './english-modules/roles'
import documents from './english-modules/documents'
import notes from './english-modules/notes'
import timeLogs from './english-modules/timeLogs'
import programs from './english-modules/programs'
import vitals from './english-modules/vitals'

const english = {
    global,
    login,
    header,
    sidebar,
    dashboard,
    communications,
    careCoordinator,
    patient,
    appointmentCalendar,
    tasks,
    timeTrackingReport,
    thresholds,
    timeLogReport,
    patientSummary,
    common,
    globalCodes,
    providers,
    inventory,
    roles,
    documents,
    notes,
    timeLogs,
    programs,
    vitals,
}

export default english